// CRC-32 (IEEE, the zip flavour), the browser copy of src/photos/crc32.ts. Computed once over
// the resized photo so the Worker can build the export zip without touching the bytes.

let table: Uint32Array | null = null;

const makeTable = (): Uint32Array => {
    const t = new Uint32Array(256);
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        t[n] = c >>> 0;
    }
    return t;
};

export function crc32(bytes: Uint8Array, seed = 0): number {
    table ??= makeTable();
    let c = (seed ^ 0xffffffff) >>> 0;
    for (let i = 0; i < bytes.length; i++) c = table[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
    return (c ^ 0xffffffff) >>> 0;
}

export async function crc32OfBlob(blob: Blob): Promise<number> {
    return crc32(new Uint8Array(await blob.arrayBuffer()));
}
